import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ILocation } from "@Common/interfaces/location";
import { getOemState, storageGetItem, storageRemoveItem, storageSetItem } from "@/Common/helpers/Storage";

interface LocationSlice {
	location: ILocation | null;
	locationId: string;
	locations: ILocation[] | null;
	loading: boolean;
}

let location: ILocation | null = null;
let locationId: string = "";
const storedLocation = storageGetItem("location");
if (storedLocation) {
	location = storedLocation as ILocation;
	locationId = location.locationId || "";
}

const initialState: LocationSlice = {
	location,
	locationId,
	locations: null,
	loading: true,
};

const LocationID = createSlice({
	initialState,
	name: "Location",
	reducers: {
		SET_LOADING: (state, { payload }) => {
			if (payload.loading !== undefined && payload.loading !== null && typeof payload.loading === "boolean") {
				state.loading = payload.loading;
			}
		},
		SET_LOCATION_ID: (state, { payload }: PayloadAction<{ locationId: string }>) => {
			state.locationId = payload.locationId;
		},
		SET_LOCATION: (
			state,
			{
				payload,
			}: PayloadAction<{
				location: ILocation | null;
			}>
		) => {
			if (payload.location) {
				const payloadLocation = { ...payload.location, oems: getOemState(payload.location.oems) };
				storageSetItem("location", payloadLocation);
				state.location = { ...payloadLocation };
			} else {
				storageRemoveItem("location");
				state.location = null;
			}
		},
		SET_LOCATIONS: (
			state,
			{
				payload,
			}: PayloadAction<{
				locations: ILocation[];
			}>
		) => {
			state.locations = [...payload.locations];
		},
	},
});

export const { actions } = LocationID;
export default LocationID.reducer;
